import { NgModule } from '@angular/core';
import { FaComponent } from './fa6.component';
import {MatIconModule} from '@angular/material/icon';


@NgModule({
    declarations: [
        FaComponent,
    ],
    imports: [
        MatIconModule,
    ],
    exports: [FaComponent]
})
export class Fa6Module {

}
